import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { useUser } from "@hooks/useUser";

export function useActiveWorkspaceAssigment() {
    const activeWorkspace = useActiveWorkspace();
    const user = useUser();

    if (!user || !activeWorkspace) {
        return null;
    }

    return (
        activeWorkspace.userAssignments?.find(
            (assignment) => assignment.userId === user.id,
        ) ?? null
    );
}
